export default "__VITE_ASSET__DjhU2YZV__"